import React, { useEffect } from 'react';

import { FallbackCard } from './visitiqCatalog.styles';

interface UnavailableFormFieldProps {
  message: string;
  setValue: (value: string) => void;
}

/**
 * A self-validating form field that can't render: its value is emptied once, so the submit button's `required` check
 * blocks a value the user never saw, such as one the agent pre-filled.
 */
const UnavailableFormField = ({ message, setValue }: UnavailableFormFieldProps): JSX.Element => {
  useEffect(() => {
    setValue('');
    // Once, on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <FallbackCard>{message}</FallbackCard>;
};

export default UnavailableFormField;
